import { stringCapitalize } from "./stringCapitalize";
import { PageNameConstant } from "../constants/PageNameConstant";
import {
  getActiveSortRecord,
  toApiSortColumn,
} from "./sortingColumn";

const fleetPageNames = [
  PageNameConstant.fleetList,
  PageNameConstant.replacementSchedule,
  PageNameConstant.maintenanceAnalysis,
  PageNameConstant.fuelAnalysis,
  PageNameConstant.fundingNewVehicle,
];

export const columnSortingMessage = (sortingColumnData) => {
  const pageSort = getActiveSortRecord(
    Array.isArray(sortingColumnData)
      ? sortingColumnData.filter((item) =>
          fleetPageNames.includes(item.pageName)
        )
      : []
  );

  if (!pageSort) return "";

  const sortColumn = pageSort.sortedColumn ?? pageSort.SortedColumn;
  const columnName = /^FleetNo$/i.test(toApiSortColumn(sortColumn))
    ? "Vehicle"
    : stringCapitalize(String(sortColumn).replace(/([a-z])([A-Z])/g, "$1 $2"));

  return `The ${columnName} column is already sorted on the ${pageSort.pageName} page.`;
};
